/**
 * Format date for email list cards:
 * - today → time only (e.g. "12:44")
 * - yesterday → use yesterdayLabel (e.g. "Ieri" / "Yesterday")
 * - other → day + short month (e.g. "13 Feb")
 */
export function formatEmailListDate(date: Date, yesterdayLabel: string): string {
    const today = new Date();
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    const key = (d: Date) =>
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

    if (key(today) === key(date)) {
        return new Intl.DateTimeFormat(undefined, { hour: "2-digit", minute: "2-digit" }).format(date);
    }
    if (key(yesterday) === key(date)) {
        return yesterdayLabel;
    }
    return date.toLocaleDateString(undefined, { day: "numeric", month: "short" });
}
